import { WidgetType } from 'widgets/WidgetType';
import { selectEstimatedTradeCostWidgetState } from 'widgets/estimatedTradeCost/widget/store/selectors';
import {
    buildComponentSlice,
    useComponentSlice,
} from 'widgets/store/component/componentSlice';

export type EstimatedTradeCostComponentState = { qty?: number };

export const initialEstimatedTradeCostComponentState: EstimatedTradeCostComponentState =
    {};

export const buildEstimatedTradeCostWidgetComponentSlice = () =>
    buildComponentSlice<EstimatedTradeCostComponentState>(
        WidgetType.EST_TRADE_COST_WIDGET,
        selectEstimatedTradeCostWidgetState,
        initialEstimatedTradeCostComponentState
    );

export const useEstimatedTradeCostWidgetComponentSlice = () =>
    useComponentSlice(buildEstimatedTradeCostWidgetComponentSlice());
